// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"b8619f18","340":"9dcd432e","348":"a31eae50","350":"f456ccfd","654":"2b25febf","704":"2e02a991","852":"b3a3c69a","868":"9896c9fb"}[chunkId] + ".css";
};